const messages = {
    nl: require('./languages/nl_NL.json')
};

export default messages;


// WEBPACK FOOTER //
// ./src/i18n/index.js